import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Get a specific piece of information
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestGetInformation = packet => {
  return {
    type: 'REQUEST_GET_INFORMATION',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveGetInformationSuccess = data => ({
  type: 'RECEIVE_GET_INFORMATION_SUCCESS',
  data
})

export const receiveGetInformationFail = data => ({
  type: 'RECEIVE_GET_INFORMATION_FAIL',
  data
})

export const tryToGetInformation = packet => (dispatch, getState) => {

  dispatch(requestGetInformation(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/knowledge/' + packet.knowledge_id + '/information/' + packet.information_id, {
      method: 'get',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveGetInformationSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveGetInformationFail({errors:e, lastSubmit: packet}));
    })
}
